import React from 'react';
import { Icon as NativeIcon } from 'semantic-ui-react';

const Icon = ({ ...props }) => <NativeIcon {...props} />;

export default Icon;
